import "./AboutMe.css";
import React from "react";

const AboutMe = () => {

    return (
        <div className="about-me">
            <h1 className="rory-about">RORY</h1>
            <p>A web developer based in Bournemouth, UK</p>
            <p className="call"> Call me.</p>
            <p className="phone">07810 760 451</p>
        </div>
    )

}

export default AboutMe;